import { ref, onMounted } from 'vue'

const deferredPrompt = ref(null)
const isInstalled = ref(false)
const isIOS = ref(false)

// 模块加载时立即注册，确保不会错过 beforeinstallprompt（它可能在组件 onMounted 之前触发）
if (typeof window !== 'undefined' && !window.__pwaListenerRegistered) {
  window.addEventListener('beforeinstallprompt', (e) => {
    logger.debug('beforeinstallprompt = ', e)
    e.preventDefault()
    deferredPrompt.value = e
  })

  window.addEventListener('appinstalled', () => {
    isInstalled.value = true
    deferredPrompt.value = null
    logger.debug('PWA installed successfully')
  })

  window.__pwaListenerRegistered = true
}

export function usePWA() {
  const checkInstallStatus = () => {
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches
    const isIOSStandalone = window.navigator.standalone === true

    isInstalled.value = isStandalone || isIOSStandalone
    isIOS.value = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream

    logger.debug('isInstalled:', isInstalled.value)
  }

  const triggerInstall = async () => {
    logger.debug('enter triggerInstall')
    if (isIOS.value) {
      logger.debug('enter triggerInstall, ios')
      return 'IOS_GUIDE'
    }

    logger.debug('enter triggerInstall, deferredPrompt = ', deferredPrompt.value)
    if (!deferredPrompt.value) {
      logger.debug('enter triggerInstall, deferredPrompt is null')
      return 'NOT_AVAILABLE'
    }

    logger.debug('enter triggerInstall, prompt')
    deferredPrompt.value.prompt()
    const { outcome } = await deferredPrompt.value.userChoice
    logger.debug('enter triggerInstall, finish')
    deferredPrompt.value = null
    return outcome
  }

  onMounted(() => {
    checkInstallStatus()
  })

  return {
    isInstalled,
    isIOS,
    canInstall: deferredPrompt,
    triggerInstall
  }
}
